"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var react_1 = __importDefault(require("react"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var MaskedInput = function (_a) {
    var mask = _a.mask, maskChar = _a.maskChar, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, label = _a.label, helperText = _a.helperText, error = _a.error, variant = _a.variant, required = _a.required, onBlur = _a.onBlur, InputProps = _a.InputProps, id = _a.id;
    return (react_1.default.createElement(react_input_mask_1.default, { id: id, mask: mask, maskChar: maskChar, value: value, onChange: onChange, onBlur: onBlur, disabled: disabled }, function (inputProps) { return (react_1.default.createElement(TextField_1.default, __assign({}, inputProps, { label: label, variant: variant, helperText: helperText, error: error, onChange: onChange, disabled: disabled, required: required, fullWidth: true, InputProps: InputProps }))); }));
};
exports.default = MaskedInput;
//# sourceMappingURL=index.js.map